var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"service"},[_c('div',{staticClass:"service__wrapper"},[_vm._l((_vm.items),function(item,key){return [_c('Menu',{key:key,attrs:{"item":item},on:{"select":_vm.onSelect}})]})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }